<mat-chip-listbox aria-label="Dog selection" class="mb-2">
    <mat-chip *ngFor="let item of selectedFilters; let i = index">
        <span class="d-block chips1">{{getActualString(item.labelType)}}</span>
        <span class="d-block chips2">{{item.from }} {{ item.from && item.to ? '-' : ''  }} {{item.to}}</span>
        <button matChipRemove (click)="this.removeFilter.emit({index:i,data:item})">
            <mat-icon>close</mat-icon>
        </button>
    </mat-chip>
</mat-chip-listbox>
